
import { Shield, MapPin, Eye, EyeOff } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface LocationPrecisionDisplayProps {
  precisionMeters: number;
  showToOthers: boolean;
  isOwnProfile?: boolean;
}

const LocationPrecisionDisplay = ({ 
  precisionMeters, 
  showToOthers, 
  isOwnProfile = false 
}: LocationPrecisionDisplayProps) => {
  const getPrecisionLabel = (meters: number) => {
    switch (meters) {
      case 100:
        return { label: "Very Precise", color: "bg-red-500/20 text-red-400", icon: Shield };
      case 300:
        return { label: "Precise", color: "bg-yellow-500/20 text-yellow-400", icon: MapPin };
      case 1000:
        return { label: "Approximate", color: "bg-blue-500/20 text-blue-400", icon: MapPin };
      case 5000:
        return { label: "General Area", color: "bg-green-500/20 text-green-400", icon: MapPin };
      default:
        return { label: "Standard", color: "bg-gray-500/20 text-gray-400", icon: MapPin };
    }
  };

  // Don't show to others if they haven't enabled it (unless it's their own profile)
  if (!isOwnProfile && !showToOthers) {
    return null;
  }

  const precision = getPrecisionLabel(precisionMeters);
  const IconComponent = precision.icon;

  return (
    <div className="flex items-center gap-3 p-3 bg-ice-white/5 rounded-lg">
      <IconComponent className="w-5 h-5 text-toxic-green flex-shrink-0" />
      <div className="flex-1">
        <span className="text-ice-white/60 text-sm">Location Precision</span>
        <div className="flex items-center gap-2 mt-1">
          <Badge className={`${precision.color} border-0 text-xs`}>
            {precision.label}
          </Badge>
          {isOwnProfile && (
            <div className="flex items-center gap-1 text-xs text-ice-white/50">
              {showToOthers ? (
                <>
                  <Eye className="w-3 h-3" />
                  <span>Visible to others</span>
                </>
              ) : (
                <>
                  <EyeOff className="w-3 h-3" />
                  <span>Private</span>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocationPrecisionDisplay;
